import '../applied_filter_view.js.coffee';# Added by Script 
Monitoring.Views.SocialContents ||= {}
Monitoring.Views.SocialContents.Filters ||= {}

class Monitoring.Views.SocialContents.Filters.AppliedSocialNetworkIdView extends Monitoring.Views.SocialContents.Filters.AppliedFilterView
  template: JST["backbone/templates/monitoring/filters/applied_social_network_id"]

  name: 'social_network_id'
  alias: 'Users'

  removeFilter: (socialNetworkId) ->
    @searchQuery.removeSocialNetworkId(socialNetworkId)

  getAppliedValues: ->
    return @searchQuery.get(@name)